<!--
Locations > directions > room from screen
@author bmk11u
-->
<template>
  <div>
    <Nav name="Directions from Room" v-bind:home="true" v-if="authenticated" />
    <Nav name="Directions from Room" v-if="!authenticated" />
    <SearchList name="room" id="roomId" label="roomName" :data="'/map/buildings/' + buildingId + '/rooms'"
      :href="'directions?toId=' + toId + '&toType=' + toType + '&fromId={roomId}&fromType=R'" :exclude="toId">
    </SearchList>
    <div id="pusher"></div>
    <Footer active="notifications" v-if="authenticated"/>
  </div>
</template>

<script>
import SearchList from '@/components/SearchList.vue'
import LocationsCommon from '@/mixins/LocationsCommon.js'
import Footer from '@/components/FooterMenu.vue'

export default {
  name: 'RoomFrom',
  components: {
    SearchList
  },
  mixins: [
    LocationsCommon,
    Footer
  ],
  data () {
    return {
      authenticated: this.$cookies.get('authenticated'),
      toId: this.$route.query.toId,
      toType: this.$route.query.toType,
      buildingId: this.$route.query.buildingId,
      buildingName: this.$route.query.buildingName
    }
  }
}
</script>
